import { type MouseEvent, useState } from 'react';
import { MoreVert } from '@mui/icons-material';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { Box, IconButton, List, ListItemButton, ListItemIcon, ListItemText, Popover } from '@mui/material';

interface ActionButtonsProps {
  onExport(): void;
  onMassiveExport(): void;
}

const ActionButtons = ({ onExport, onMassiveExport }: ActionButtonsProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const open = Boolean(anchorEl);
  const id = open ? 'action-popover' : undefined;

  const onClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const onClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box>
      <IconButton onClick={onClick}>
        <MoreVert />
      </IconButton>
      <Popover id={id} open={open} anchorEl={anchorEl} onClose={onClose}>
        <List>
          <ListItemButton onClick={onExport}>
            <ListItemIcon>
              <FileDownloadIcon />
            </ListItemIcon>
            <ListItemText primary="Exportar" secondary="Descarga la lista de cursos de la tabla." />
          </ListItemButton>
          <ListItemButton onClick={onMassiveExport}>
            <ListItemIcon>
              <CloudDownloadIcon />
            </ListItemIcon>
            <ListItemText
              primary="Generar Reporte"
              secondary="Permite seleccionar los cursos a incluir en el reporte."
            />
          </ListItemButton>
        </List>
      </Popover>
    </Box>
  );
};

export default ActionButtons;
